import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import * as resActions from "../../modules/resources";
import ResourcesCounter from "Components/resourcesCounter/ResourcesCounter";
import Loader from "Components/loader/Loader";
import t from "Utils/translation";

import PropTypes from "prop-types";
import Chart from "chart.js";

import cx from "classnames";
import s from "./dashboard.scss";
import ServiceIntro from "../../components/serviceIntro/ServiceIntro";
import { MailboxIntro, mailbox } from "../../icons";

Chart.defaults.global.defaultFontFamily = "Lato";

const ContextTypes = {
  router: PropTypes.object,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

class DashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.addNew = this.addNew.bind(this);

    this.state = {
      aliasDomainsChartsDays: 30,
      domainsChartsDays: 30,
      emailAccountChartsDays: 30,
      aliasEmailAccountChartsDays: 30,
    };
  }

  componentDidMount() {
    this.props.getCharts();
  }

  componentDidUpdate(prevProps) {
    const { loggedUserType } = this.props;

    if (prevProps.areChartsLoading && !this.props.areChartsLoading && loggedUserType !== "EmailAccount") {
      if (loggedUserType !== "postmaster") {
        this.renderActivationChart("domainsCharts", this.extractDays(this.props.charts.domains_activations, 30), {
          label: "Active Domains",
          backgroundColor: "#effcf5",
          borderColor: "#42de82",
          fullDataset: this.props.charts.domains_activations,
        });
      }

      this.renderActivationChart("emailAccountCharts", this.extractDays(this.props.charts.emails_activations, 30), {
        label: "Email Account",
        backgroundColor: "#91cbff",
        borderColor: "#45a6ff",
        fullDataset: this.props.charts.emails_activations,
      });

      this.renderActivationChart(
        "aliasDomainsCharts",
        this.extractDays(this.props.charts.alias_domains_activations, 30),
        {
          label: "Active Alias Domains",
          backgroundColor: "#fef6df",
          borderColor: "#fbc330",
          fullDataset: this.props.charts.alias_domains_activations,
        },
      );

      this.renderActivationChart(
        "aliasEmailAccountCharts",
        this.extractDays(this.props.charts.alias_emails_activations, 30),
        {
          title: "Email account attivati negli ultimi 30 giorni",
          label: "Alias Email Account",
          backgroundColor: "#ee938b",
          borderColor: "#e45548",
          fullDataset: this.props.charts.alias_emails_activations,
        },
      );

      this.renderQuotasChart();

      if (loggedUserType !== "postmaster") {
        this.renderTopCharts("topDomainQuota", this.props.charts.top_domains_quota, {
          title: "Email account attivati negli ultimi 30 giorni",
          label: "Alias Email Account",
          backgroundColor: "#deefff",
          borderColor: "#45a6ff",
          fullDataset: this.props.charts.top_domains_quota,
        });
      }
    }
  }

  addNew() {
    this.props.history.push("/domains/new");
  }

  extractDays(data, days) {
    let k = Object.keys(data);

    // if days is a subset of data available
    // get only the requested
    if (days < k.length) {
      k = k.slice(k.length - days);
    }

    return _.pick(data, k);
  }

  changeTimeframe(chart, timeFrame) {
    this.setState({ [chart + "Days"]: timeFrame });
    let d = this.extractDays(this[chart].data.datasets[0].originalData, timeFrame);

    let nd = _.map(d, (qty, date) => ({
      y: qty,
      x: new Date(date),
    }));

    this[chart].data.datasets[0].data = nd;
    this[chart].update();
  }

  renderActivationChart(id, data, opts = {}) {
    const { label, backgroundColor, borderColor, fullDataset } = opts;

    var ctx = document.getElementById(id);
    this[id] = new Chart(ctx, {
      type: "line",
      data: {
        datasets: [
          {
            label: label,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            borderWidth: 3,
            originalData: fullDataset,
            data: _.map(data, (qty, date) => ({
              y: qty,
              x: new Date(date),
            })),
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        title: {
          display: false,
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                // stepSize: 100
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(0, 0, 0, 0)",
              },
              type: "time",
            },
          ],
        },
      },
    });
  }

  renderQuotasChart() {
    const { quota_percentages } = this.props.charts;

    let labels = [];
    let data = [];

    _.each(quota_percentages, (qty, size) => {
      // exclude postmaster 50MB
      if (parseInt(size) !== 50) {
        labels.push(`${size}GB`);
        data.push(qty);
      }
    });

    var ctx = document.getElementById("quotasCharts");

    var myChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            hoverBorderWidth: 0,
            backgroundColor: [
              "#8B454C", // 1GB
              "#915169", // 2GB
              "#8B6186", // 3GB
              "#79759E", // 4GB
              "#5B89AC", // 5GB
              "#369CAE", // 6GB
              "#21ACA3", // 7GB
              "#41B98F", // 8GB
              "#70C375", // 16GB
              "#75C473", // 25GB
              "#A3C95E", // 50MB
            ],
          },
        ],
      },
      options: {
        tooltips: {},

        maintainAspectRatio: false,
        title: {
          display: false,
          text: "Numero di caselle email per quota",
          fontFamily: "Lato",
          fontSize: "14",
          padding: 20,
        },
        legend: {
          display: true,
          position: "right",
        },
      },
    });
  }

  bytesToSize(bytes) {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "n/a";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    if (i === 0) return `${bytes} ${sizes[i]}`;
    return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
  }

  renderTopCharts(id, data, opts = {}) {
    const { backgroundColor, borderColor, fullDataset } = opts;
    var ctx = document.getElementById(id);

    let labels = [];
    let d = [];

    _.each(data, (v, k) => {
      labels.push(k);
      d.push(v);
    });

    this[id] = new Chart(ctx, {
      type: "horizontalBar",
      data: {
        labels,
        datasets: [
          {
            label: "",
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            borderWidth: 3,
            originalData: fullDataset,
            data: d,
          },
        ],
      },
      options: {
        tooltips: {
          callbacks: {
            label: (data) => this.bytesToSize(data.xLabel),
          },
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                callback: (value) => this.bytesToSize(value),
              },
            },
          ],
        },
      },
    });
  }

  renderTitle(name, title, days = []) {
    return (
      <div className={s.headerChart}>
        <div>{title}</div>

        <div className={s.daySwitch}>
          {days.map((d) => (
            <div
              onClick={() => this.changeTimeframe(name, d)}
              className={cx(s.itemSwitch, { [s.active]: this.state[name + "Days"] === d })}
              key={d}
            >
              {d}
              <span>{t("button.days")}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  render() {
    let { charts, areChartsLoading } = this.props;

    if (areChartsLoading) return <Loader />;

    return (
      <div className={s.dashboardContainer}>
        <div className={s.dashboard}>
          <div className={s.content}>
            <div className={s.introSection}>
              <ServiceIntro
                className={s.serviceIntro}
                iconSvg={mailbox}
                title={t("mailbox.intro.title")}
                description={t("mailbox.intro.description")}
                imageSvg={MailboxIntro}
              />
            </div>
            <div className={cx("sectionTitle", s.titleSection)}>Dashboard</div>
            <div className={s.numberSection}>
              <ResourcesCounter summary={charts.summary} />
            </div>
            <div className={s.chartSection}>
              <div className={cx(s.maxQuotaChart, s.wrapChart)}>
                <div className={s.headerChart}>
                  <div>{t("dashboard.chart.title.maxQuota.email")}</div>
                </div>

                <div className={s.chartCanvasContainer}>
                  <canvas className={s.dataChart} id="quotasCharts" />
                </div>
              </div>

              <div className={cx(s.domainChart, s.wrapChart)}>
                {this.renderTitle("domainsCharts", t("dashboard.chart.title.domains.active"), [30, 60])}

                <div className={s.chartCanvasContainer}>
                  <canvas className={s.dataChart} id="domainsCharts" />
                </div>
              </div>

              <div className={cx(s.emailAccountChart, s.wrapChart)}>
                {this.renderTitle("emailAccountCharts", t("dashboard.chart.title.emails.active"), [30, 60])}

                <div className={s.chartCanvasContainer}>
                  <canvas className={s.dataChart} id="emailAccountCharts" />
                </div>
              </div>

              <div className={cx(s.domainAliasChart, s.wrapChart)}>
                {this.renderTitle("aliasDomainsCharts", t("dashboard.chart.title.alias.domain.active"), [30, 60])}

                <div className={s.chartCanvasContainer}>
                  <canvas className={s.dataChart} id="aliasDomainsCharts" />
                </div>
              </div>

              <div className={cx(s.emailAliasChart, s.wrapChart)}>
                {this.renderTitle("aliasEmailAccountCharts", t("dashboard.chart.title.alias.email.active"), [30, 60])}

                <div className={s.chartCanvasContainer}>
                  <canvas className={s.dataChart} id="aliasEmailAccountCharts" />
                </div>
              </div>

              <div className={cx(s.topDomainChart, s.wrapChart)}>
                <div className={s.headerChart}>
                  <div>{t("dashboard.chart.title.topQuota.domain")}</div>
                </div>
                <div className={s.chartCanvasContainer}>
                  <canvas className={s.dataChart} id="topDomainQuota" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DashboardPage.contextTypes = ContextTypes;
// Selectors
const getFormattedActivationsData = _.memoize((chartsData) => {
  let datas = {};

  const keys = ["emails_activations", "domains_activations", "alias_domains_activations", "alias_emails_activations"];

  keys.forEach((v) => {
    const d = _.map(chartsData[v], (v, k) => ({ date: k, value: v }));
    return (datas[v] = d.length === 0 ? [{}] : d);
  });

  let tops = _.reverse(
    _.sortBy(
      _.map(chartsData["top_domains_quota"], (v, k) => ({ name: k, value: v })),
      ["value"],
    ),
  );
  datas["top_domains_quota"] = tops.length === 0 ? [{}] : tops;
  tops = _.reverse(
    _.sortBy(
      _.map(chartsData["top_domains_emails"], (v, k) => ({
        name: k,
        value: v,
      })),
      ["value"],
    ),
  );
  datas["top_domains_emails"] = tops.length === 0 ? [{}] : tops;

  return datas;
});

const mapStateToProps = (state) => {
  const chartsData = resActions.getData("charts.data.0", state);

  return {
    loggedUserType: state.session.user.type,
    charts: chartsData,
    areChartsLoading: resActions.isResourceLoading("charts", state),
    ...getFormattedActivationsData(chartsData),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCharts: (queryParams) => {
    dispatch(resActions.callApi("getCharts", "charts", queryParams));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);
